import React from "react";
import { Route, Routes } from "react-router-dom";

// screens
import MainScreen from "../Views/MainScreen/MainScreen";
// import WorkInProgress from "../Views/Common/work-in-progress";
import NotFound404 from "../Views/Common/not-found-404";
import CustomersScreen from "../Views/MainScreen/CustomersScreen/CustomersScreen";
import AccountsScreen from "../Views/MainScreen/AccountsScreen/AccountsScreen";
import TransactionsScreen from "../Views/MainScreen/TransactionsScreen/TransactionsScreen";
import DashboardScreen from "../Views/MainScreen/DashboardScreen/DashboardScreen";
import ReportsScreenNavigator from "./ReportsScreenNavigator";
import AgentScreen from "../Views/MainScreen/AgentScreen/AgentScreen";
import ExpenseScreen from "../Views/MainScreen/ExpenseScreen/ExpenseScreen";
import ProfileScreen from "../Views/MainScreen/ProfileScreen/ProfileScreen";

function MainScreenNavigator(props) {
  return (
    <MainScreen {...props}>
      <Routes>
        <Route path="/" element={<DashboardScreen />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/account" element={<AccountsScreen />} />
        <Route path="/customer" element={<CustomersScreen />} />
        <Route path="/agent" element={<AgentScreen />} />
        <Route path="/expense" element={<ExpenseScreen />} />
        <Route path="/transaction" element={<TransactionsScreen />} />
        <Route path="/report/*" element={<ReportsScreenNavigator />} />

        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </MainScreen>
  );
}
export default MainScreenNavigator;
